export const CONTAINER_ID = 'shoppable-image-container';
export const OVERLAY_ID = 'shoppable-image-overlay';
export const NONE_EXPANDED = -1;
